
const cryptoTypes = {
    setCryptoList: 'SET_CRYPTO_LIST',
    errorCrypto: 'ERROR_CRYPTO',
};

export default cryptoTypes;